export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    slug: 'bladder-control-training',
    name: '憋尿控制训练方法',
    description: '系统学习憋尿控制的科学训练方法，从基础到进阶，逐步提升膀胱控制能力。涵盖凯格尔运动、定时排尿、延迟排尿等核心技巧。',
    icon: 'ri-timer-line',
    articleCount: 5,
    imageSeq: 'cat-training',
  },
  {
    slug: 'bladder-capacity-improvement',
    name: '膀胱控制能力提升',
    description: '了解膀胱的生理结构与工作机制，掌握提升膀胱储尿容量的有效策略，改善排尿控制力。',
    icon: 'ri-heart-pulse-line',
    articleCount: 4,
    imageSeq: 'cat-capacity',
  },
  {
    slug: 'frequent-urination-solutions',
    name: '尿频改善方案',
    description: '针对尿频、尿急等常见问题的综合改善方案，涵盖生活方式调整、饮食管理及专业治疗建议。',
    icon: 'ri-drop-line',
    articleCount: 5,
    imageSeq: 'cat-frequency',
  },
  {
    slug: 'urination-holding-limits',
    name: '憋尿时间限制',
    description: '深入解析憋尿的安全边界与潜在风险，提供科学的时间限制参考及自我保护指南。',
    icon: 'ri-alert-line',
    articleCount: 4,
    imageSeq: 'cat-limits',
  },
  {
    slug: 'bladder-training-techniques',
    name: '膀胱训练技巧',
    description: '汇集专业泌尿科推荐的膀胱训练技巧，包含盆底肌训练、生物反馈疗法及行为矫正策略。',
    icon: 'ri-run-line',
    articleCount: 4,
    imageSeq: 'cat-techniques',
  },
  {
    slug: 'urination-control-health-guide',
    name: '排尿控制健康指南',
    description: '全面的排尿健康管理知识库，涵盖预防保健、自我监测、就医指引及康复护理全流程。',
    icon: 'ri-book-read-line',
    articleCount: 4,
    imageSeq: 'cat-guide',
  },
];